import { Injectable } from '@angular/core';

// rxjs
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class TooltipService {

  public tooltipItem$: Subject<any> = new Subject();
  public removeAllTooltips$: Subject<any> = new Subject();

  handleTooltip(message: any) {
    this.tooltipItem$.next(message);
  }
}
